import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LucideAngularModule, LucideIconData } from 'lucide-angular';

@Component({
  selector: 'app-icon',
  imports: [LucideAngularModule],
  template: `
    <lucide-icon
      [img]="icon()"
      [size]="size()"
      [color]="color()"
      [strokeWidth]="strokeWidth()"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'contents' },
})
export class IconComponent {
  icon = input.required<LucideIconData>();
  size = input<number>(20);
  color = input<string>('currentColor');
  strokeWidth = input<number>(1.5);
}
